import type { Technique } from '../types';
import { CIRCLE_PACKING_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type CirclePackingState } from './render';

export const circlePacking: Technique<CirclePackingState> = {
  id: 'circle-packing',
  name: 'Circle Packing',
  category: 'packing',
  description: 'Formen füllen den Raum um die Buchstaben, jede so gross wie sie noch passt.',
  params: CIRCLE_PACKING_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
